import {NgModule, Optional, SkipSelf} from '@angular/core';
import {LayoutModule} from '../layout/layout.module';
import {HttpClientModule} from '@angular/common/http';
import {SvgIconsModule} from '../svg-icons/svg-icons.module';


@NgModule({
	declarations: [],
	imports: [LayoutModule, HttpClientModule, SvgIconsModule]
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) {
			throw new Error('CoreModule has already been loaded. You should only import Core modules in the AppModule only.');
		}
	}
}
